<template>
  <div>
    <Modal
      id="disconnect"
      :hide-footer="true"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">Отключение пользователя</span>
      </template>
      <div slot class="flex flex-col items-stretch p-8">
        <p class="text-center text-16px leading-22px mb-6 text-muted">
          Вы действительно хотите отключить данного пользователя?
        </p>
        <div class="flex flex-row align-self-stretch space-x-2">
          <button
            class="btn btn-xs btn-outline-primary flex-grow"
            @click="$bvModal.hide('disconnect')">Отмена</button>
          <button
            class="btn btn-xs btn-primary flex-grow"
            v-b-modal="'disconnect-data'">Да, отключить</button>
        </div>
      </div>
    </Modal>
    <Modal
      id="disconnect-data"
      :hide-footer="true">
      <template v-slot:modal-title>
        <span class="modal-title">Отключение пользователя</span>
      </template>
      <div slot class="flex flex-col items-stretch p-8">
        <p class="text-center text-16px leading-22px mb-6 text-muted">
          Пожалуйста оставьте комментарий о причине отключения ниже
        </p>
        <div class="flex flex-col mb-6">
          <Input
            :textarea="true"
            placeholder="Ваш комментарий"
            :invalid="$v.blocking.$dirty && $v.blocking.blockingReason.$invalid"
            v-model="blockingReason"/>
          <div
            class="flex flex-col mt-1"
            v-if="$v.blocking.$dirty && $v.blocking.$invalid">
            <small
              class="font-rubik text-danger"
              v-if="$v.blocking.$invalid">Введите комментарий</small>
          </div>
        </div>
        <div class="flex flex-row align-self-stretch space-x-2">
          <button
            class="btn btn-xs btn-outline-primary flex-grow"
            @click="$bvModal.hide('disconnect-data')">Отмена</button>
          <button
            class="btn btn-xs btn-primary flex-grow"
            @click="block">Да, отключить</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Modal from '@/components/Modal.vue';
import Input from '@/components/Input.vue';

export default {
  components: {
    Modal,
    Input,
  },
  validations: {
    blockingReason: { required },
    blocking: ['blockingReason'],
  },
  data() {
    return {
      blockingReason: '',
    };
  },
  methods: {
    block() {
      this.$v.blocking.$touch();
      if (!this.$v.blocking.$invalid) {
        this.$emit('block', this.blockingReason);
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (event, modalId) => {
      switch (modalId) {
        case 'disconnect-data':
          this.blockingReason = '';
          this.$v.blocking.$reset();
          break;
        default:
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
};
</script>
